// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"aa427b3e891cf5676c4e","883":"6586651eb5d971556d6b"}[chunkId] + ".js";
};